// Input validation utility functions

/**
 * Only allow numbers (0-9) and navigation keys
 * @param {KeyboardEvent} e - The keyboard event
 */
export const handleNumbersOnly = (e) => {
	const allowedKeys = [
		'Backspace',
		'Delete',
		'ArrowLeft',
		'ArrowRight',
		'ArrowUp',
		'ArrowDown',
		'Tab',
		'Enter',
	]
	const isNumber = e.key >= '0' && e.key <= '9'

	if (!isNumber && !allowedKeys.includes(e.key)) {
		e.preventDefault()
	}
}

/**
 * Only allow text (no numbers 0-9)
 * @param {KeyboardEvent} e - The keyboard event
 */
export const handleTextOnly = (e) => {
	// Prevent numbers 0-9
	if (e.key >= '0' && e.key <= '9') {
		e.preventDefault()
	}
}

/**
 * Only allow letters, spaces and navigation keys (strict text validation)
 * @param {KeyboardEvent} e - The keyboard event
 */
export const handleLettersAndSpacesOnly = (e) => {
	const allowedKeys = [
		'Backspace',
		'Delete',
		'ArrowLeft',
		'ArrowRight',
		'ArrowUp',
		'ArrowDown',
		'Tab',
		'Enter',
	]

	const isLetter = /^[a-zA-Zㄱ-ㅎㅏ-ㅣ가-힣]$/.test(e.key)
	const isSpace = e.key === ' '

	if (!isLetter && !isSpace && !allowedKeys.includes(e.key)) {
		e.preventDefault()
	}
}

/**
 * Handle paste events to filter numbers only
 * @param {ClipboardEvent} e - The paste event
 */
export const handleNumbersOnlyPaste = (e) => {
	e.preventDefault()
	const paste = (e.clipboardData || window.clipboardData).getData('text')
	const numbersOnly = paste.replace(/[^0-9]/g, '')
	e.target.value = numbersOnly
}

/**
 * Handle paste events to filter text only (remove numbers)
 * @param {ClipboardEvent} e - The paste event
 */
export const handleTextOnlyPaste = (e) => {
	e.preventDefault()
	const paste = (e.clipboardData || window.clipboardData).getData('text')
	const textOnly = paste.replace(/[0-9]/g, '')
	e.target.value = textOnly
}

// 단순 형태
export const shortStrRegx = /^.{1,10}$/ // 1자~10자 문자열
export const mediumStrRegx = /^.{1,20}$/ // 1자~20자 문자열
export const longStrRegx = /^.{1,40}$/ // 1자~40자 문자열
export const maxStrRegx = /^.{1,}$/s // 1자 이상 문자열 (줄바꿈 문자 포함)
export const postNumberWithZeroRegx = /^(0|[1-9][0-9]*)$/ // 0과 양수
export const posNumberRegx = /^[1-9][0-9]*$/ // 양수
export const numberRegx = /^[0-9]*$/ // 숫자
export const levelOrBreakRegx = /^(0|[1-9][0-9]*|break(\d+)?)$/ // 0과 양수 또는 "break" 또는 "break1", "break2" 등

// 특정 상황
export const pwRegx = /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{6,20}$/ // 비밀번호 정규표현식
export const nameRegx = /^[a-zA-Z가-힣]{1,20}$/ // 이름 정규표현식
export const emailRegx = /^.{1,20}@[a-zA-Z]{1,12}\.[a-z.]{2,8}$/ // 이메일 정규표현식
export const internationalNumberRegx = /^[0-9]{1,4}$/ // 국가번호 정규표현식
export const contactRegx = /^[0-9]{1,20}$/ // 연락처 정규표현식
export const certificationNumberRegx = /^[0-9]{6,6}$/ // 인증번호 정규표현식
export const dateRegx = /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/ // date 정규표현식
export const datetimeRegx =
	/^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01]) (0[0-9]|1[0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/ // datetime 정규표현식
